/** Formats free-typed input into "+7 (999) 999-99-99" as the user types. */
export function formatPhoneInput(value) {
  const digitsOnly = value.replace(/\D/g, '');
  if (!digitsOnly) return '';

  let digits = digitsOnly[0] === '8' ? '7' + digitsOnly.slice(1) : digitsOnly;
  if (digits[0] !== '7') digits = '7' + digits;
  digits = digits.slice(0, 11);

  const rest = digits.slice(1);
  let result = '+7';
  if (rest.length) result += ' (' + rest.slice(0, 3);
  if (rest.length >= 3) result += ')';
  if (rest.length > 3) result += ' ' + rest.slice(3, 6);
  if (rest.length > 6) result += '-' + rest.slice(6, 8);
  if (rest.length > 8) result += '-' + rest.slice(8, 10);
  return result;
}
